import * as RdxHoverCard from '@radix-ui/react-hover-card';
import { ReactNode } from 'react';

type BaseHoverCardComponentsProps = {
  className?: string;
  children: ReactNode,
}

function Root({ children }: BaseHoverCardComponentsProps) {
  return (
    <RdxHoverCard.Root openDelay={100} closeDelay={100}>
      {children}
    </RdxHoverCard.Root>
  )
}

function Trigger({ children, className }: BaseHoverCardComponentsProps) {
  return (
    <RdxHoverCard.Trigger className={className}>
      {children}
    </RdxHoverCard.Trigger>
  )
}

type ContentProps = BaseHoverCardComponentsProps & {
  contentContainer?: any;
  side?: 'left' | 'bottom' | 'right' | 'top'
}

export function Content({ children, side = 'bottom', className, contentContainer }: ContentProps) {
  return (
    <RdxHoverCard.Portal container={contentContainer}>
      <RdxHoverCard.Content side={side} className={className} sideOffset={14}>
        {children}
      </RdxHoverCard.Content>
    </RdxHoverCard.Portal>
  )
};

export const HoverCard = {
  Root,
  Trigger,
  Content
}